export enum SETTING_KEY_USER {
	ACTS_FILTERS = 'acts_filters',
	MOBILE_ACTS_FILTERS = 'mobile_acts_filters',
	AGREEMENT = 'agreement',
	MERCHANT_STATUS = 'merchant_status',
	CONTRACT = 'contract',
	CREATIVE = 'creative',
	ORGANIZATION = 'organization',
	REPORT = 'report',
	BANKEMPLOYEES = 'bankEmployees',
	DEPARTMENTS = 'departments',
	ORDERS_FILTERS = 'orders_filters',
	MOBILE_FILTERS = 'mobile_filters',
	BUSINESSAPP = 'businessapp',
	PARTNER_REQUEST = 'partner_request',
	CABINET_MOBILE_FILTERS = 'cabinet_mobile_filters',
	REGISTRATORCABINET = 'registratorCabinet',
	ELECTRONIC_AGREEMENTS = 'electronic_agreements',
	ORDERS = 'orders',
	CONTRACTS_REGISTRY = 'contracts_registry',
	REGISTRY_BUSINESS_ACCESS = 'registry_business_access',
	PARTNER_ONE_DAY = 'partner_one_day',
	NOTIFICATIONS = 'notifications',
	WIDGETS = 'widgets',
	DASHBOARD_PARTNER_ID = 'dashboard_partner_id',
	BG_EVENT_NOTIFICATION = 'bg_event_notification',
	BG_EVENT_NOTIFICATION_EMAIL = 'bg_event_notification_email',
	EMAIL_CONFIRMATION_CODE = 'email_confirmation_code',
}
